import type { Theme, SxProps } from '@mui/material/styles';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { EmptyContent } from '../empty-content';
import { DEFAULT_TABLE_COL_SPAN } from './utils';

// ----------------------------------------------------------------------

export type TableNoDataProps = {
  notFound: boolean;
  /**
   * Columns to span. Pass the table's real column count for grids where it
   * varies, so the row covers the full width.
   */
  colSpan?: number;
  /**
   * Styles for the containing cell. `TableCell`'s own padding insets the empty
   * state from the grid's edges, so pass `{ p: 0 }` where it should sit flush.
   */
  cellSx?: SxProps<Theme>;
  sx?: SxProps<Theme>;
};

export function TableNoData({
  notFound,
  colSpan = DEFAULT_TABLE_COL_SPAN,
  cellSx,
  sx,
}: TableNoDataProps) {
  return (
    <TableRow>
      {notFound ? (
        <TableCell colSpan={colSpan} sx={cellSx}>
          <EmptyContent filled sx={[{ py: 10 }, ...(Array.isArray(sx) ? sx : [sx])]} />
        </TableCell>
      ) : (
        <TableCell colSpan={colSpan} sx={{ p: 0 }} />
      )}
    </TableRow>
  );
}
